import {
    Assets,
    Container,
    Graphics,
    Sprite,
    Text,
} from 'pixi.js';
import { SCREEN_HEIGHT, SCREEN_WIDTH, FONT_UI } from '../../GameConst';
import { InfoTextBar } from '../../components/InfoTextBar';
import { StatusWindow } from '../../components/StatusWindow';
import { LayerNameBar } from './LayerNameBar';
import { ScrollBox } from '@pixi/ui';
import { sceneManager } from '../../SceneManager';
import { BattleScene } from '../BattleScene';
import { CommonButton, ON_BUTTON_EVENT } from '../../components/CommonButton';
import { BACK_TOWER_01 } from '../../CommonAssets';

export const SELECT_TOWER_EVENT = 'SELECT_TOWER_EVENT';

export class TowerSelectLayer extends Container {
    constructor(towers){
        super();

        const background = new Sprite(Assets.get(BACK_TOWER_01.name));
        background.eventMode = 'static';
        this.addChild(background);

        const infoText = new InfoTextBar('挑戦するタワーを選択してください');
        this.addChild(infoText);

        const statusWindow = new StatusWindow();
        this.addChild(statusWindow);

        const layerNameBar = new LayerNameBar('タワー選択', true);
        this.addChild(layerNameBar);

        const scrollBox = new ScrollBox({
            // background: 0XFFFFFF,
            elementsMargin: 10,
            width: SCREEN_WIDTH * 0.8 + 20,
            height: SCREEN_HEIGHT * 0.48,
            radius: 0,
            padding: 10,
            disableEasing: false,
            disableDynamicRendering: true,
        });
        this.addChild(scrollBox);
        scrollBox.x = SCREEN_WIDTH * 0.5 - scrollBox.width * 0.5;
        scrollBox.y = SCREEN_HEIGHT * 0.35;

        const towerUis = [];
        towers.forEach(tower => {
            const towerUi = new Graphics().beginFill(0x000000).drawRect(0, 0, SCREEN_WIDTH * 0.8, SCREEN_HEIGHT * 0.1);
            const towerUiText = new Text(`${tower.name}   クリア階数 : ${tower.maxFloor}F`, {
                fontFamily: FONT_UI,
                fontSize: SCREEN_HEIGHT * 0.02,
                fill: 'white',
            });
            towerUi.addChild(towerUiText);
            const towerUiButton = new CommonButton(towerUi, {ignorePivot:true});
            towerUiButton.on(ON_BUTTON_EVENT, () => {
                this.emit(SELECT_TOWER_EVENT, tower.id);
            });
            towerUis.push(towerUiButton);
        });

        scrollBox.addItems(towerUis.reverse());
    }
}
